import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <GoogleOAuthProvider clientId='1043868080407-gstqg30mn22ir0k630ikufhko2ae0rmh.apps.googleusercontent.com'>
          <App />
        </GoogleOAuthProvider>
      </AuthProvider>
    </Provider>
  </React.StrictMode>
);
